/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import queryString from 'query-string';
import Box from 'grommet/components/Box';

class LoginView extends React.Component {

  constructor(props) {
    super(props);
    this.state = { ...props.login };
  }

  async componentDidMount() {
    localStorage.removeItem('refresh-token-inprogress');
    const { location: { protocol, hostname, host }, clientIdParam } = window;
    const { location: { search } } = this.props;
    const isSwitchUserPopup = window.opener && window.opener.authData;
    const responseTypeParam = 'response_type=code';
    const redirectUriParam = `redirect_uri=${protocol}//${hostname}/login`;
    const { code, redirect } = queryString.parse(search);
    const scope = 'scope=SOLUMINA';
    const endPoint = '/oauth2/authorize';
    let authUrl = `${protocol}//${hostname}${endPoint}?${responseTypeParam}&client_id=${clientIdParam}&${redirectUriParam}&${scope}`;
    authUrl = redirect ? `${authUrl}&redirect=${redirect}` : authUrl;
    const ssoAuthUrl = `${protocol}//${host}/solumina-auth/ssologin.jsp?responseURL=${protocol}//${host}/sso-login`;
    const { fetchExternalSignInParameters } = this.props;
    const { result: { ssoEnable } } = await fetchExternalSignInParameters();
    if (localStorage.token && !isSwitchUserPopup) {
      this.onTokenFound();
    } else if (typeof code !== 'undefined' && code != null) {
      const { postLogin } = this.props;
      postLogin(code, protocol, hostname);
    } else if (!ssoEnable) {
      window.location.href = authUrl;
    } else if (ssoEnable) {
      window.location.href = ssoAuthUrl;
    }
    window.localStorage.setItem('external', false);
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps.login });
    const { login, clockIn } = this.props;
    if (!login.loginStatus && nextProps.login.loginStatus) {
      clockIn();
    }
    if (nextProps.login.msg) {
      localStorage.setItem('signInErrorMessage', nextProps.login.msg);
    }
    if (nextProps.login.redirect) {
      window.location.href = nextProps.redirectTo;
    }
    if (nextProps.login.tokenExpired) {
      window.location.href = '/login';
    }
  }

  componentDidUpdate() {
    const { invalidForm, loginResult } = this.state;
    const { clearLoginStatus } = this.props;
    if (invalidForm && loginResult !== '') {
      clearLoginStatus();
    }
    if (loginResult && window.opener) {
      const { callback } = window.opener.authData;
      callback(true);
      window.close();
    }
  }

  onTokenFound() {
    const { checkUserPrivileges } = this.props;
    checkUserPrivileges();
  }

  render() {
    const { loginStatus } = this.state;
    if (loginStatus) {
      return (
        <Box className="login-redirect mb-10">
          <Box className="login-padding"><FormattedMessage id="messages.redirecting" /></Box>
        </Box>
      );
    }
    return null;
  }
}

LoginView.propTypes = {
  postLogin: PropTypes.func.isRequired,
  clockIn: PropTypes.func.isRequired,
  login: PropTypes.object,
  redirectTo: PropTypes.string,
  clearLoginStatus: PropTypes.func,
  checkUserPrivileges: PropTypes.func.isRequired,
  fetchExternalSignInParameters: PropTypes.func,
  location: PropTypes.object.isRequired
};

LoginView.defaultProps = {
  redirectTo: '/',
  login: {},
  clearLoginStatus: () => { },
  fetchExternalSignInParameters: () => { }
};

export default LoginView;
